import { Button } from '~/components/ui/button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '~/components/ui/dialog';
import { Text } from '~/components/ui/text';

export default function ConfirmationModal({
  open,
  callTrigger,
  handleClose,
  headerText,
  alertText,
  buttonText1 = 'OK',
  buttonText2 = 'Cancel',
}: Readonly<{
  open: boolean;
  callTrigger: () => void;
  handleClose: () => void;
  headerText: string;
  alertText: string;
  buttonText1: string;
  buttonText2: string;
}>) {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) handleClose();
      }}
      open={open}
    >
      <DialogContent>
        <DialogTitle>{headerText}</DialogTitle>
        <Text className='text-gray-500 whitespace-pre-line'>{alertText}</Text>
        <DialogActions>
          <Button variant='outlined' color='neutral' onClick={handleClose}>
            {buttonText1}
          </Button>
          <Button variant='solid' color='secondary' onClick={callTrigger}>
            {buttonText2}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
